export enum MedSummaryAssetTabs {
  ALL_ENTRIES = 'all-entries',
  SOURCE_FILES = 'source-files',
}

export const getMedSummaryAssetTabName = (tab: MedSummaryAssetTabs) => {
  switch (tab) {
    case MedSummaryAssetTabs.ALL_ENTRIES:
      return 'All Entries'
    case MedSummaryAssetTabs.SOURCE_FILES:
      return 'Source Files'
  }
}

export enum MedSummaryAssetRouteSegments {
  ADD_FILES = 'add-files',
}

// Update polling backs off 5s -> 10s -> 15s while a run is active.
export const kMedSummaryAssetPollIntervalsMs = [5000, 10000, 15000]

// Uploads go through the file pipeline first, so this is limited to the types its type policy
// accepts (paxton_app/file_pipeline/type_policy.py) that the billing-summary pipeline can also
// convert (SUPPORTED_SOURCE_MIME_TYPES in paxton_app/med_summary/pipeline/source_pdf.py):
// non-PDF sources are converted to PDF by the update pipeline (AI-94).
export const kMedSummaryAssetAcceptedFileTypes = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/tiff': ['.tif', '.tiff'],
}

// The OS file picker's `accept` attribute: every accepted MIME type plus its extensions.
export const kMedSummaryAssetAcceptAttribute = Object.entries(kMedSummaryAssetAcceptedFileTypes)
  .flatMap(([mimeType, extensions]) => [mimeType, ...extensions])
  .join(',')

// Collaborators can read a matter's billing summary, but only the owner can build, update, or
// edit it. The backend enforces the same split: member-scoped reads, owner-scoped writes.
export const kMedSummaryOwnerOnlyBuildMessage = 'Only the matter owner can initiate a billing summary build.'
export const kMedSummaryOwnerOnlyBuildOwnerMessage = 'Only they can initiate a billing summary build.'
export const kMedSummaryOwnerOnlyUpdateMessage = 'Only the matter owner can update this billing summary.'
